import Storage from '../../../lib/Storage'
import { isEmpty } from '../../../utils/isEmpty'
import StackAPI from '../../../lib/StackAPI'
import { captureException } from '@sentry/react'

export const ENDPOINT = '/partners/vendor/product'

export const getDigitalOrderCsv = async (productId: string) => {
  const role = Storage().getActiveRole()

  if (isEmpty(role)) return { error: 'no active role' }

  const { get } = StackAPI()

  const headers = {
    Accept: 'text/csv',
    'Content-Type': 'text/csv'
  }

  const request = {
    path: ENDPOINT,
    params: { product_id: productId },
    headers,
    responseType: 'blob'
  }

  try {
    const response = await get<string>(request)

    return response.data
  } catch (error) {
    captureException(error, { extra: { role } })
    return { error: 'unknown error' }
  }
}
